
import Component from "vue-class-component"
import BeneficiaryNominationChart from "@/superannuation/BeneficiaryNominationChart.vue"
import MetricTrendWidget from "@/superannuation/MetricTrendWidget.vue"
import PageHeader from "@/superannuation/PageHeader.vue"
import PercentOutlineWidget from "@/components/dashboard/PercentOutlineWidget.vue"
import CircularProgressWidget from "@/components/dashboard/CircularProgressWidget.vue"
import IconBannerWidget from "@/components/dashboard/IconBannerWidget.vue"
import SuperScoreProgressWidget from "@/components/dashboard/SuperScoreProgressWidget.vue"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import FilterDimensionSelect from "@/superannuation/FilterDimensionSelect.vue"
import Vue from "vue"
import {Inject, Prop} from "vue-property-decorator"
import {PlanService} from "@/superannuation/PlanService"
import {DateRangeService} from "@/DateRangeService"
import {MetricAggregated, MetricStore} from "@/cube/metric-data/MetricStore"
import {MemberSnapshotMeasure} from "@/cube"
import AnimatedNumber from "@/ui/AnimatedNumber.vue"
import BuiltWithAmcharts from "@/BuiltWithAmcharts.vue"

@Component({
  components: {
    BuiltWithAmcharts,
    AnimatedNumber,
    FilterDimensionSelect,
    ChangeRateWidget,
    SuperScoreProgressWidget,
    IconBannerWidget,
    CircularProgressWidget,
    PercentOutlineWidget,
    PageHeader,
    BeneficiaryNominationChart,
    MetricTrendWidget,
  },
})
export default class DetailPage extends Vue {
  @Prop()
  metricStore: MetricStore

  @Inject()
  planService: PlanService

  @Inject()
  dateRangeService: DateRangeService

  countTotalMembers: number = <any>null
  countMetricAggregated: MetricAggregated = <any>null
  isFilteredVisible = false

  pageReady = true

  get filteredAmount() {
    return this.countMetricAggregated.end?.amount
  }

  async mounted() {
    await this.metricStore.setEngagedOnly(this.planService.engagedOnly)

    this.$watch(
      () => this.planService.current,
      async plan => {
        this.pageReady = false
        if (plan != null) {
          await this.dateRangeService.setPlan(plan.id)
        }

        if (this.dateRangeService.dateRangeSelector?.selected !== undefined) {
          await this.metricStore.update(
            this.planService.current!.id,
            this.dateRangeService.dateRangeSelector.selected
          )
        }

        this.pageReady = true
      }
    )
    this.$watch(
      () => this.dateRangeService.dateRangeSelector?.selected,
      async dateRange => {
        if (dateRange != null) {
          this.countMetricAggregated = this.metricStore.get(
            MemberSnapshotMeasure.countMembers
          )

          if (this.planService.current) {
            await this.metricStore.update(
              this.planService.current.id,
              dateRange
            )
            this.countTotalMembers = this.countMetricAggregated.end!.totalAmount
          }
        }
      },
      {immediate: true}
    )

    this.$watch(
      () => this.planService.engagedOnly,
      async () => {
        await this.metricStore.setEngagedOnly(this.planService.engagedOnly)
      }
    )
  }

  async onSelectViewChange(url: string) {
    await this.$router.push(`/super/${url}`)
  }

  async applyFilter(filters: Array<any>) {
    // TODO should remove the filters as they are removed from the selection
    // TODO do not set it more than once
    // TODO move filter transform to filterDimensionSelect?
    console.log("runFilterQuery", filters)

    const matchers = filters
      .filter(filter => filter.value.length > 0)
      .reduce((acc, filter) => {
        acc[filter.name] = filter.value.map((option: any) => option.value)
        return acc
      }, {})

    console.log("runFilterQuery matchers", matchers)

    await this.metricStore.setFilter(matchers)
  }

  // TODO type dimensionFilter
  async runFilterQuery(filters: Array<any>) {
    const dimensions = filters.map(filter => filter.name)
    console.log("runFilterQuery", filters)
    if (dimensions.length === 0) {
      await this.applyFilter([])
      this.isFilteredVisible = false
    } else {
      this.isFilteredVisible = true
    }
  }
}
